module.exports = __webpack_public_path__ + "img/GR_bw.93c67562.jpg";